import React, { PropsWithChildren } from 'react'

export const Region: React.FC<PropsWithChildren> = ({ children }) => (
  <div className="max-w-xl mr-auto box-border m-0">{children}</div>
)
